import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { withSx } from "ui/atoms/Modal";
import { TriggerableDialog } from "ui/molecules/Dialog";
import ActionPanel from "ui/molecules/ActionPanel";
import {
    PaymentMethodDetail,
    PaymentMethodDetailProvider,
    usePaymentMethodContext
} from "../../PaymentMethod";

const AddPaymentMethod = () => {
    const {
        isProcessing,
        hasActiveChanges,
        updateOrCreate,
        reset
    } = usePaymentMethodContext();

    return (
        <TriggerableDialog
            TriggerComponent={({ onClick }) => (
                <LoadingButton
                    variant='contained'
                    color='secondary'
                    loading={isProcessing}
                    onClick={onClick}
                >
                    Add New Method
                </LoadingButton>
            )}
            DialogActionsComponent={({ onClose }) => (
                <ActionPanel
                    sx={{
                        border: 'none',
                        p: 0,
                        m: 0
                    }}
                    CancelActionProps={{
                        disabled: isProcessing
                    }}
                    SaveActionProps={{
                        children: 'Create Method',
                        disabled: !hasActiveChanges(),
                        loading: isProcessing
                    }}
                    onCancel={onClose}
                    onSave={() => (
                        updateOrCreate()
                            .then(onClose)
                            .then(reset)
                    )}
                />
            )}
            ModalProps={{
                disableCloseOnBackdropClick: true,
                onClose: reset,
                DialogProps: withSx({
                    maxWidth: 'lg'
                }),
                titleSlot: 'Add New Method'
            }}
        >
            <PaymentMethodDetail />
        </TriggerableDialog>
    );
};

export default memo(() => (
    <PaymentMethodDetailProvider
        useCaseDiscriminationKey='create'
    >
        <AddPaymentMethod />
    </PaymentMethodDetailProvider>
));
